// 导入所有接口
import api from './api'

const myPlugin = {
  install(app) {
    if (this.installed) {
      return;
    }

    this.installed = true;

    Object.defineProperties(app.config.globalProperties, {
      // 注意，此处挂载在 app 原型的 $api 对象上
      $api: {
        get() {
          return api
        }
      }
    });
  }
}

export default myPlugin;
